<template>
    <div class="loginPage">
        <v-container class="custom-container bg-register">
            <v-row no-gutters>
                <v-col md="12">
                    <div class="top-bar-register">
                        <div class="logo-wrapper">
                            <v-img
                                width="25px"
                                height="25px"
                                src="../../assets/logo.png"
                            ></v-img>
                            <span class="ml-3">Forex CRM</span>
                        </div>
                        <LanguageMenu></LanguageMenu>
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center" class="mt-10 mb-10" no-gutters>
                <v-col md="6" sm="9">
                    <h3 class="justify-center">OTP</h3>
                    <v-form class="deposit-form password-field">
                        <div class="form-details">
                            <p class="check-email-text">
                                We have sent an OTP to your email address.
                                Please enter the OTP within the next two
                                minutes.
                                <v-chip class="ma-2" color="white">
                                    {{ formattedTime }}
                                </v-chip>
                            </p>
                            <div class="otp-field">
                                <v-otp-input
                                    @input="USER_OTP"
                                    length="6"
                                    type="number"
                                ></v-otp-input>
                            </div>
                            <div class="otp-timer">
                                <v-btn
                                    v-if="countdownTime === 0"
                                    class="bg-otp"
                                    @click.prevent="resendOTP"
                                    >Resend OTP</v-btn
                                >
                                <v-btn
                                    v-else
                                    class="bg-otp"
                                    color="greenMain"
                                    :disabled="!registerInfo.receivedOTP"
                                    @click.prevent="SUBMITOTP"
                                    >Submit</v-btn
                                >
                            </div>
                        </div>
                    </v-form>
                </v-col>
            </v-row>
            <v-row justify="center" no-gutters>
                <v-col md="3">
                    <p class="emailLink text-center">
                        Contact us at
                        <a href="mailto:support@forexcrm.com"
                            >support@forexcrm.com</a
                        >
                        if you have problems
                    </p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { mapMutations, mapActions, mapState } from "vuex";
import { AUTHENTICATION__ACTIONS } from "@/store/action-types";
import { AUTHENTICATION__MUTATIONS } from "@/store/mutation-types";

export default {
    components: { LanguageMenu },
    data() {
        return {
            currentRouteName: "",
            show1: false,
            email: "",
            password: "",
            countdownTime: 120,
        };
    },
    created() {
        this.currentRouteName = this.$route.name;
    },
    computed: {
        ...mapState("authentication", ["registerInfo"]),
        formattedTime() {
            const minutes = Math.floor(this.countdownTime / 60);
            const seconds = this.countdownTime % 60;
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        },
    },
    methods: {
        ...mapActions("authentication", {
            SUBMITOTP: AUTHENTICATION__ACTIONS.SUBMITOTP,
            SENDREGISTEROTP: AUTHENTICATION__ACTIONS.SENDREGISTEROTP,
        }),

        ...mapMutations("authentication", {
            USER_OTP: AUTHENTICATION__MUTATIONS.USER_OTP,
        }),

        startCountdown() {
            const timerInterval = setInterval(() => {
                if (this.countdownTime > 0) {
                    this.countdownTime -= 1;
                } else {
                    clearInterval(timerInterval);
                }
            }, 1000);
        },

        resendOTP() {
            this.countdownTime = 120;
            this.startCountdown();
            this.SENDREGISTEROTP();
        },
    },

    mounted() {
        document.title = "Send OTP";
        this.startCountdown();
    },
};
</script>
